<template>
  <div id="preloader">
    <div id="loader" class="loader">
      <div class="loader-container">
        <div class="loader-icon"><img src="assets/img/logo/preloader.png" alt="Preloader" /></div>
      </div>
    </div>
  </div>
  <button class="scroll__top scroll-to-target" data-target="html">
    <i class="fas fa-angle-up"></i>
  </button>

  <Header />

  <router-view />

  <Footer />
</template>

<style></style>
